export default __webpack_public_path__ + "static/media/Venkatesh_Radhakrishnan-banyantree.84dd1396.png";